import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";
import Link from "../../../../elements/Link";

var ListItem = function ListItem(_ref) {
  var href = _ref.href,
      text = _ref.text,
      icon = _ref.icon;
  var getClassName = getClassNameFactory(ListItem.displayName);
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      modifiers: classNames(icon ? "icon" : null)
    })
  }, href ? /*#__PURE__*/React.createElement(Link, {
    href: href,
    iconLeft: icon
  }, text) : /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "inner"
    })
  }, icon ? /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "icon"
    })
  }, icon) : null, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "text"
    })
  }, text)));
};

ListItem.displayName = "ListItem";
export default ListItem;